module.exports = __webpack_public_path__ + "img/mw.b7ef09c6.svg";